import React from 'react'
import { FooterContactMenu } from '../../footer.props'
import styled from 'styled-components'
import { Link } from '@sentecacommerce-theme/lib'
import {
  IconFacebook,
  IconInstagram,
  IconYoutube,
  Typography,
} from '../../../Common'
import { Config } from '../../../../config/index'

const icons: { [key: string]: JSX.Element } = {
  facebook: <IconFacebook width="2.4rem" height="2.5rem" />,
  instagram: <IconInstagram width="2.4rem" height="2.4rem" />,
  youtube: <IconYoutube width="2.8rem" height="2.8rem" />,
}

export const Contacts = ({ socialItems, label }: FooterContactMenu) => {
  const renderSocialIconList = () => {
    return socialItems.map((item) => (
      <SocialIcon key={`${item.url}__${item.media}`}>
        <a
          target="_blank"
          rel="noreferrer"
          href={item.url}
          aria-label={item.media}
        >
          {icons[item.media] || null}
        </a>
      </SocialIcon>
    ))
  }

  return (
    <Container>
      <Title>{label}</Title>
      <SocialContainer>{renderSocialIconList()}</SocialContainer>
    </Container>
  )
}

const Container = styled.div`
  line-height: 2.6rem;
  letter-spacing: 0.06rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;

  & a {
    transition: all 0.1s ease;
    &:hover {
      color: ${({ theme }) => theme.palette.silverTree};
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    font-size: 1.7rem;
    display: block;
    padding-left: 2.1rem;
  }
`

const SocialContainer = styled.ul.attrs({
  className: 'row gx-4 gx-lg-5',
})`
  justify-content: flex-end;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    justify-content: flex-start;
  }
`

const Title = styled(Typography).attrs({
  className: '',
  as: 'div',
  variant: '4',
})`
  font-weight: 600;
  line-height: 1.7rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    font-size: 1.6rem !important;
    padding-bottom: 2rem;
  }
`

const SocialIcon = styled.li.attrs({
  className: 'col-auto',
})`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;

  &:first-child {
    margin: 0 -0.4rem;
  }
`
